import { render } from "./businessDetails.vue?vue&type=template&id=edb95a2e&scoped=true"
import script from "./businessDetails.vue?vue&type=script&lang=js"
export * from "./businessDetails.vue?vue&type=script&lang=js"

import "./businessDetails.vue?vue&type=style&index=0&id=edb95a2e&scoped=true&lang=css"

import exportComponent from "D:\\Web\\hkjt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edb95a2e"]])

export default __exports__